import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";

import SezarAttribute from "./SezarAttribute";

export default Node.create({
    name: "sezar",
    inline: true,
    group: "inline",

    addAttributes() {
        return {
            name: {
                default: "name",
            },
            "data-id": {
                default: "default",
            },
            whatsappMode: {
                default: false,
            },
            allowedAttributes: {
                default: [],
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: "sezar",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ["sezar", mergeAttributes(HTMLAttributes)];
    },

    addNodeView() {
        return VueNodeViewRenderer(SezarAttribute);
    },
});
